import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DirectivesModule } from '../directives/directives.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TargetSelectionComponent } from './target-selection/target-selection.component';
import { TranslationComponent } from './translations/translations.component';
import { PluginComponent } from './plugins/plugins.component';
import { TranslateAppComponent } from './translate-app.component';

@NgModule({
  declarations: [
    TranslateAppComponent,
    TargetSelectionComponent,
    TranslationComponent,
    PluginComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule,
    FormsModule,
    ReactiveFormsModule
  ],
  providers: [],
  exports: [TranslateAppComponent]
})
export class TranslateAppModule {
  customElementComponent: Type<any> = TranslateAppComponent;
}

